import Vue from "vue";
import VueRouter from "vue-router";
import Vuei18n from "vue-i18n";

Vue.use(VueRouter);
Vue.use(Vuei18n);

import translationsEn from "@/locales/en.json";
import translationsEs from "@/locales/es.json";

const i18n = new Vuei18n({
  locale: window.localStorage.lenguaje ? window.localStorage.lenguaje : "es",
  fallbackLocale: "es",
});

i18n.setLocaleMessage("en", translationsEn);
i18n.setLocaleMessage("es", translationsEs);

import Principal from "@/components/Layouts/Principal";
import Login from "@/components/Login";
import Register from "@/components/Register";
import FinalRegister from "@/components/FinalRegister";
import Recovery from "@/components/Recovery";

import Master from "@/components/Layouts/Master";
import Notifications from "@/components/Dashboard/Notifications";
import OrdenCompra from "@/components/Dashboard/OrdenCompra";
import Documentacion from "@/components/Dashboard/Documentacion";
import PagoPendiente from "@/components/Dashboard/PagoPendiente";

const getStoredUser = () => {
  try {
    return window.localStorage.user ? JSON.parse(window.localStorage.user) : null;
  } catch {
    return null;
  }
};

const hasActiveSession = () => {
  const token = window.localStorage.token;
  const user = getStoredUser();

  return Boolean(token && token !== "undefined" && user && user.id);
};

export default new VueRouter({
  mode: "history",
  routes: [
    {
      path: "",
      component: Master,
      beforeEnter: (to, from, next) => {
        if (!hasActiveSession()) {
          window.localStorage.removeItem("user");
          window.localStorage.removeItem("token");
          return next(`/${i18n.t("rutas.inicio_sesion")}`);
        }

        return next();
      },
      redirect: `/${i18n.t("rutas.notifications")}`,
      children: [
        {
          path: `/${i18n.t("rutas.notifications")}`,
          component: Notifications,
        },
        {
          path: `/${i18n.t("rutas.ordenes_compra")}`,
          component: OrdenCompra,
        },
        {
          path: `/${i18n.t("rutas.documentacion")}`,
          component: Documentacion,
        },
        {
          path: `/${i18n.t("rutas.pagos_pendientes")}`,
          component: PagoPendiente,
        },
      ],
    },
    {
      path: "",
      component: Principal,
      children: [
        { path: `/${i18n.t("rutas.inicio_sesion")}`, component: Login },
        { path: `/${i18n.t("rutas.registrarse")}`, component: Register },
      ],
    },
    { path: "/auth/register/:code", component: FinalRegister },
    { path: "/auth/recovery/:code", component: Recovery },
  ],
});
